"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_router_1 = require("react-router");
var bind_1 = require("../bind");
var with_update_url_1 = require("./with_update_url");
var search_filters_1 = require("./search_filters");
var controlled_input_1 = require("./controlled_input");
function inputValuesFromFilter(filter) {
    return {
        minValue: search_filters_1.getRangeValue(filter, 'min').value || '',
        maxValue: search_filters_1.getRangeValue(filter, 'max').value || '',
    };
}
var RangeFacet = /** @class */ (function (_super) {
    tslib_1.__extends(RangeFacet, _super);
    function RangeFacet(props) {
        var _this = _super.call(this, props) || this;
        _this.state = inputValuesFromFilter(_this.props.filter);
        return _this;
    }
    RangeFacet.prototype.componentDidUpdate = function (prevProps) {
        var current = inputValuesFromFilter(this.props.filter);
        var prev = inputValuesFromFilter(prevProps.filter);
        if (current.minValue !== prev.minValue || current.maxValue !== prev.maxValue) {
            this.setState(current);
        }
    };
    RangeFacet.prototype.handleChange = function (update) {
        this.setState(update);
    };
    RangeFacet.prototype.handleSubmit = function (evt) {
        var _a;
        evt && evt.preventDefault();
        var minParam = search_filters_1.getRangeValue(this.props.filter, 'min');
        var maxParam = search_filters_1.getRangeValue(this.props.filter, 'max');
        var newUrl = this.props.updateUrl(this.props.location, (_a = {},
            _a[minParam.key] = this.state.minValue,
            _a[maxParam.key] = this.state.maxValue,
            _a));
        this.props.router.push(newUrl);
    };
    RangeFacet.prototype.render = function () {
        return (React.createElement("div", { className: "facet" },
            React.createElement("div", { className: "facet__heading" }, this.props.filter.name),
            React.createElement("div", { className: "search-input-group" },
                React.createElement("form", { onSubmit: this.handleSubmit },
                    React.createElement("div", { className: "search-input-group__inner" },
                        React.createElement("div", { className: "search-input-group__field" },
                            React.createElement(controlled_input_1.default, { inputType: "text", fieldName: "minValue", inputName: "minValue", inputValue: this.state.minValue, pattern: "[\\d.,]*", updateField: this.handleChange, placeholder: "Min", autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false })),
                        React.createElement("div", { className: "search-input-group__field" },
                            React.createElement(controlled_input_1.default, { inputType: "text", fieldName: "maxValue", inputName: "maxValue", inputValue: this.state.maxValue, pattern: "[\\d.,]*", updateField: this.handleChange, placeholder: "Max", autoComplete: "off", autoCorrect: "off", autoCapitalize: "off", spellCheck: false })),
                        React.createElement("button", { className: "search-input-group__button", type: "submit" }))))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], RangeFacet.prototype, "handleChange", null);
    tslib_1.__decorate([
        bind_1.default
    ], RangeFacet.prototype, "handleSubmit", null);
    return RangeFacet;
}(React.Component));
exports.RangeFacet = RangeFacet;
exports.default = with_update_url_1.withUpdateURL(react_router_1.withRouter(RangeFacet));
//# sourceMappingURL=range_facet.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/range_facet.js
// module id = +QpO
// module chunks = 0 1 2 3 9 10 14 20